<template>
  <g>
    <defs>
      <path
        id="document-download@1x-a"
        d="M19.4,9.246 C19.3906253,9.16332141 19.3725245,9.08186752 19.346,9.003 L19.346,8.922 C19.302727,8.82946178 19.2450054,8.74439835 19.175,8.67 L19.175,8.67 L13.775,3.27 L13.775,3.27 C13.7006016,3.19999458 13.6155382,3.14227297 13.523,3.099 L13.433,3.099 C13.3454876,3.05220284 13.2514363,3.01882979 13.154,3 L7.7,3 C6.20883118,3 5,4.20883118 5,5.7 L5,18.3 C5,19.7911688 6.20883118,21 7.7,21 L16.7,21 C18.1911688,21 19.4,19.7911688 19.4,18.3 L19.4,9.3 C19.4,9.3 19.4,9.3 19.4,9.246 Z M14,6.069 L16.331,8.4 L14.9,8.4 C14.4029437,8.4 14,7.99705627 14,7.5 L14,6.069 Z M17.6,18.3 C17.6,18.7970563 17.1970563,19.2 16.7,19.2 L7.7,19.2 C7.20294373,19.2 6.8,18.7970563 6.8,18.3 L6.8,5.7 C6.8,5.20294373 7.20294373,4.8 7.7,4.8 L12.2,4.8 L12.2,7.5 C12.2,8.99116882 13.4088312,10.2 14.9,10.2 L17.6,10.2 L17.6,18.3 Z M13.361,14.061 L13.1,14.331 L13.1,12 C13.1,11.5029437 12.6970563,11.1 12.2,11.1 C11.7029437,11.1 11.3,11.5029437 11.3,12 L11.3,14.331 L11.039,14.061 C10.68609,13.70809 10.11391,13.70809 9.761,14.061 C9.40809004,14.41391 9.40809004,14.98609 9.761,15.339 L11.561,17.139 C11.6465933,17.2209366 11.7475238,17.2851651 11.858,17.328 C12.0758359,17.4242791 12.3241641,17.4242791 12.542,17.328 C12.6524762,17.2851651 12.7534067,17.2209366 12.839,17.139 L14.639,15.339 C14.99191,14.98609 14.99191,14.41391 14.639,14.061 C14.28609,13.70809 13.71391,13.70809 13.361,14.061 L13.361,14.061 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" fill-rule="nonzero" xlink:href="#document-download@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>